import { useVisibleContainer } from "../hooks/useVisibleContainer";

// Route-effect component for "/watch-together". Renders nothing -
// WatchTogetherScreen.tsx (mounted unconditionally in AppRoot) owns the
// actual rendering into #watchTogetherView, which this only shows/hides.
// No data-load effect needed - appState.media/togetherSchedules are both
// already loaded elsewhere (AuthGate.tsx's startProtectedFeatures()).
export function WatchTogetherRouteScreen() {
  useVisibleContainer("watchTogetherView");
  return null;
}
